import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import type { RootState } from ".";

export type UserStatsSchema = {
  username: string | undefined;
  mixType: string | undefined;
};

type UserStatsState = UserStatsSchema;

const initialState: UserStatsState = {
  username: undefined,
  mixType: undefined,
};

export const userStatsSlice = createSlice({
  name: "userStats",
  initialState,
  reducers: {
    setUserStats: (_state, action: PayloadAction<UserStatsSchema>) => {
      return action.payload;
    },
    updateUserStats: (state, action: PayloadAction<Partial<UserStatsSchema>>): UserStatsState => {
      return { ...state, ...action.payload };
    },
    removeUserStats: () => {
      return initialState;
    },
  },
});

export const { setUserStats, updateUserStats, removeUserStats } = userStatsSlice.actions;

export function useUserStats() {
  return useSelector((state: RootState) => {
    return state.userStats;
  });
}

export default userStatsSlice.reducer;
